import { FC, Fragment } from 'react';
import { ICustomPageSection, SectionType } from '../../../models';
import { Add, Clear } from '@mui/icons-material';
import { getRandomNegativeNumber } from '../../../helpers';
import { isValidUrl, getInvalidUrlMessage } from '../../../helpers/customPage';
import { DEFAULT_SECTION } from './ManageCustomPage';
import { IconButton, Box, TextField, Button, Grid, Typography } from '@mui/material';

interface IYouTubeVideoSection {
  parentSections: ICustomPageSection[];
  sections: ICustomPageSection[];
  setSections: (val: ICustomPageSection[]) => void;
  index: number;
  parentIndex: number;
}

//Anatomy of Your Garage
//Garage Door Sensors
//Brick Lintels
//Sink Stoppers & Plungers
export const YouTubeVideoSection: FC<IYouTubeVideoSection> = ({ sections, parentSections, setSections, parentIndex, index }) => {
  // use this to deeply copy sections so we don't modify the original array
  const copy: ICustomPageSection[] = JSON.parse(JSON.stringify(parentSections));
  return (
    <>
      <Typography variant="h6">YouTube Video Section</Typography>
      <Typography variant="caption" component="p" sx={{ marginBottom: '1rem' }}>
        Add video links to show up in a carousel
      </Typography>
      <Grid container spacing={1}>
        {sections.map((sec, subSectionIndex) => {
          const currentItem = copy[parentIndex].sections[index].sections[subSectionIndex];
          return (
            <Fragment key={`${subSectionIndex}`}>
              <Grid item xs={12} md={5.5}>
                <TextField
                  size="small"
                  label="Video Name"
                  autoComplete="nope"
                  variant="outlined"
                  value={sec.linkText}
                  fullWidth
                  required
                  onChange={e => {
                    currentItem.linkText = e.target.value;
                    // update the section name with the same name of the video link text
                    currentItem.name = e.target.value;
                    setSections(copy);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={5.5}>
                <TextField
                  size="small"
                  label="Video Link"
                  autoComplete="nope"
                  variant="outlined"
                  value={sec.linkUrl}
                  fullWidth
                  required
                  onChange={e => {
                    currentItem.linkUrl = e.target.value;
                    setSections(copy);
                  }}
                  error={isValidUrl(currentItem.linkUrl)}
                  helperText={getInvalidUrlMessage(currentItem.linkUrl, true)}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <IconButton
                  color="error"
                  onClick={() => {
                    const result = window.confirm('Are you sure you want to remove this video item?');
                    if (result) {
                      const newItems = copy[parentIndex].sections[index].sections.filter(l => l.customPageSectionId !== sec.customPageSectionId);
                      copy[parentIndex].sections[index].sections = newItems;
                      setSections(copy);
                    }
                  }}
                >
                  <Clear />
                </IconButton>
              </Grid>
            </Fragment>
          );
        })}
      </Grid>
      <Box marginTop="1rem">
        <Button
          color="secondary"
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            const randomNumber = getRandomNegativeNumber();
            copy[parentIndex].sections[index].sections.push({
              ...DEFAULT_SECTION,
              name: 'Video Name Placeholder',
              customPageSectionId: randomNumber,
              type: SectionType.VIDEO_ITEM,
              sortOrder: copy[parentIndex].sections[index].sections.length + 1
            });
            setSections(copy);
          }}
        >
          Add Video
        </Button>
      </Box>
    </>
  );
};
